import { DocxIcon, PdfIcon, XlsxIcon } from '@/components/icons/file-type-icons'

/**
 * FileTypeIcon Component
 * Renders an appropriate icon based on the file type provided
 * Supports PDF, Word and Excel file types
 *
 * @param {string} fileType - The type of file (e.g. pdf, doc, docx, xlsx, xls)
 * @returns {JSX.Element | null} - Returns an icon component or null if file type is not supported
 */
export function FileTypeIcon({
  fileType,
  iconSize = 'size-5',
}: {
  fileType?: string
  iconSize?: string
}) {
  // Common size class for all icons
  const iconClass = iconSize
  const normalized = fileType?.trim().toLowerCase().replace(/^\./, '')

  // Handle PDF files (case insensitive)
  if (normalized === 'pdf') {
    return (
      <div className="relative">
        <PdfIcon className={iconClass} />
      </div>
    )
  }
  // Handle Word documents
  else if (normalized === 'docx' || normalized === 'doc') {
    return (
      <div className="relative">
        <DocxIcon className={`${iconClass} text-blue-600`} />
      </div>
    )
  }
  // Handle Excel spreadsheets
  else if (normalized === 'xlsx' || normalized === 'xls') {
    return (
      <div className="relative">
        <XlsxIcon className={`${iconClass} text-emerald-600`} />
      </div>
    )
  }

  // Return null if file type is not supported
  return null
}
